import React, { useState, useEffect } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import { HomePage } from "./components/HomePage";
import { AboutPage } from "./components/AboutPage";
import { SettingsPage } from "./components/SettingsPage";
import { ArchivedChallengesPage } from "./components/ArchivedChallengesPage";
import { JoinChallengesPage } from "./components/JoinChallengesPage";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { DataRequest } from "./components/DataRequest";
import { MaterialChallenge } from "./components/challenges/MaterialChallenge";
import { CreateChallenge } from "./components/challenges/CreateChallenge";
import { LeaderboardPage } from "./components/leaderboard/LeaderboardPage";
import {
  ArchivedDecksPage,
  CreateDeck,
  JoinDecksPage,
  MaterialDeck,
} from "./components/decks";
import { trackPageView } from "./utils/analytics";

function Router() {
  const location = useLocation();
  const [transitionClass, setTransitionClass] = useState('');
  const [previousPath, setPreviousPath] = useState('/');

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Track page view for analytics
    trackPageView(currentPath);
    
    // Determine if this is a forward or backward transition
    const isGoingHome = currentPath === '/';
    const isComingFromHome = previousPath === '/';
    
    let newTransitionClass = '';
    
    if (isGoingHome && previousPath !== '/') {
      // Going to home from another page - backward transition
      newTransitionClass = 'page-transition-backward-enter';
    } else if (isComingFromHome && currentPath !== '/') {
      // Going from home to another page - forward transition
      newTransitionClass = 'page-transition-forward-enter';
    } else if (currentPath !== previousPath) {
      // Other transitions - default to forward
      newTransitionClass = 'page-transition-forward-enter';
    }
    
    setTransitionClass(newTransitionClass);
    setPreviousPath(currentPath);
    
    // Clear transition class after animation completes
    if (newTransitionClass) {
      const timer = setTimeout(() => {
        setTransitionClass('');
      }, 400); // Updated to match the longer animation duration
      return () => clearTimeout(timer);
    }
  }, [location.pathname, previousPath]);

  return (
    <div className={transitionClass}>
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route exact path="/about" component={AboutPage} />
        <Route exact path="/settings" component={SettingsPage} />
        <Route exact path="/archived-challenges" component={ArchivedChallengesPage} />
        <Route exact path="/join-challenges" component={JoinChallengesPage} />
        <Route exact path={"/challenge"} component={MaterialChallenge} />
        <Route exact path={"/challenges"} component={MaterialChallenge} />
        {/*backwards compatibility*/}
        <Route exact path={"/challenge.html"} component={MaterialChallenge} />
        <Route exact path={"/create_challenge"} component={CreateChallenge} />
        <Route exact path={"/create-deck"} component={CreateDeck} />
        <Route exact path={"/archived-decks"} component={ArchivedDecksPage} />
        <Route exact path={"/join-decks"} component={JoinDecksPage} />
        <Route exact path={"/deck"} component={MaterialDeck} />
        <Route exact path={"/leaderboard"} component={LeaderboardPage} />
        <Route exact path={"/privacy-policy"} component={PrivacyPolicy} />
        <Route exact path={"/data-request"} component={DataRequest} />
      </Switch>
    </div>
  );
}

export default Router;
